import React, { useCallback, useState, useEffect, useMemo } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";
import MenuItem from "@mui/material/MenuItem";
import { useFormik } from "formik";
import * as yup from "yup";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styles } from "../../../assets/styles/styles";
import Dragndrop from "../dragndrop/Dragndrop";
import Preview from "../dragndrop/Preview";
import { MdHome } from "react-icons/md";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { uploadTrading } from "../../store/actions/items";
import { storage } from "../../../firebase/firebase-config";

const MySwal = withReactContent(Swal);

const membershipOptions = [
  { value: "members",  label: "NuCore Access" },
  { value: "goldPlan", label: "NuCore Elite" },
];
const levelOptions = [
  { value: "beginner", label: "Básico" },
  { value: "intermediate", label: "Intermedio" },
  { value: "advanced", label: "Avanzado" },
];
const AddTrading = ({ refresh, category }) => {
  const [value, setValue] = useState("community");
  const [files, setFiles] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState("basic");
  const [selectedMembership, setSelectedMembership] = useState("public");

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const clearAddedItems = () => {
    setFiles([]);
  };

  useEffect(() => {
    // Clear added items when the component is loaded
    setFiles([]); // Clear the added files array
  }, []);

  useEffect(() => {
    // Make sure to revoke the data uris to avoid memory leaks
    files.forEach((file) => URL.revokeObjectURL(file.preview));
  }, [files]);

  const handleLevelChange = (event) => {
    setSelectedLevel(event.target.value);
  };

  const handleMembershipChange = (event) => {
    setSelectedMembership(event.target.value);
  };

  const formik = useFormik({
    initialValues: {
      contentType: value,
      name: "",
      category: "",
      clickMe: "",
      imageURL: "",
      section: "",
      streamURL: "",
      isMembersOnly: false,
      isGoldPlan: false,
      type: "",
      description: "",
      videoURL: "",
      orderNumber: 0,
    },
    enableReinitialize: true,
    validationSchema: () => {
      const validationSchema = yup.object({
        name: yup.string("Enter the name").required("Required field"),
        // Add validation rules for common fields
      });

      return validationSchema;
    },
    onSubmit: (values) => {
      submitForm(values);
    },
  });

  const submitForm = async (values) => {
    MySwal.fire({
      title: "¿Confirm?",
      text: "¿Está seguro que quiere agregar este item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Agregar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // Upload to Firebase Storage
        // const file = files[0];
        // const storageRef = storage.ref();
        // const imageRef = storageRef.child(
        //   `images/items/${value === "pro" ? "pro" : "lab"}/${file.name}`
        // );
        // await imageRef.put(file);

        // const imageURL = await imageRef.getDownloadURL();

        // values.imageURL = imageURL;

        let members = false;
        let goldPlan = false;

        if (selectedMembership === "members") {
          members = true;
          goldPlan = false;
        } else if (selectedMembership === "goldPlan") {
          members = true;
          goldPlan = true; // Set goldPlan to true for the "goldPlan" membership
        }
        const data = {
          name: values.name,
          description: values.description,
          imageURL: values.imageURL,
          streamURL: values.streamURL,
          isMembersOnly: members,
          isGoldPlan: goldPlan,
          section: selectedLevel,
          videoURL: values.videoURL.includes("youtube")
            ? values.videoURL + "&"
            : values.videoURL,
          cdate: new Date(),
          orderNumber: values.orderNumber,
        };

        try {
          await uploadTrading(data, category);
          MySwal.fire("Item Guardado!", "", "success");
          refresh();
          formik.resetForm();
          removeAll(); // Clear the files after submission
        } catch (error) {
          console.log(error);
          MySwal.fire("Hubo un error al guardar el item", "", "error");
        }
      }
    });
  };

  const onDrop = useCallback((acceptedFiles) => {
    setFiles(
      acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      )
    );
  }, []);

  const removeAll = () => {
    setFiles([]);
  };

  return (
    <Grid container alignItems="center" justifyContent="center">
      <Grid
        item
        lg={6}
        sm={8}
        xs={12}
        sx={[styles.cardStyle, { minHeight: "65vh" }]}
        className=" add-media-card mb-4 "
      >
        <form onSubmit={formik.handleSubmit} className="m-auto p-2 w-75">
          <Typography
            sx={styles.cardTitleStyle}
            variant="h6"
            className="center"
          >
            Agregar Items en{" "}
            {category === "trading:forex" ? "Forex" : "Cryptos"}
          </Typography>
          <Box sx={styles.innerCardStyle}>
            <TextField
              margin="dense"
              variant="standard"
              fullWidth
              id="section"
              name="section"
              select
              label="Nivel"
              value={selectedLevel}
              onChange={handleLevelChange}
            >
              {levelOptions.map((option) => {
                return (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                );
              })}
            </TextField>

            <TextField
              margin="dense"
              variant="standard"
              fullWidth
              id="name"
              name="name"
              label="Nombre"
              value={formik.values.name}
              onChange={formik.handleChange}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
            />

            <TextField
              margin="dense"
              variant="standard"
              fullWidth
              id="description"
              name="description"
              label="Descripción"
              type="description"
              value={formik.values.description}
              onChange={formik.handleChange}
              error={
                formik.touched.description && Boolean(formik.errors.description)
              }
              helperText={
                formik.touched.description && formik.errors.description
              }
            />

            <TextField
              margin="dense"
              variant="standard"
              fullWidth
              id="details"
              name="details"
              label="Detalles"
              type="details"
              value={formik.values.details}
              onChange={formik.handleChange}
              error={formik.touched.details && Boolean(formik.errors.details)}
              helperText={formik.touched.details && formik.errors.details}
            />
            <TextField
              margin="dense"
              variant="standard"
              fullWidth
              id="videoURL"
              name="videoURL"
              label="URL de Video"
              value={formik.values.videoURL}
              onChange={formik.handleChange}
              error={formik.touched.videoURL && Boolean(formik.errors.videoURL)}
              helperText={formik.touched.videoURL && formik.errors.videoURL}
            />
            <TextField
              margin="dense"
              variant="standard"
              fullWidth
              id="streamURL"
              name="streamURL"
              label="URL de transmisión"
              value={formik.values.streamURL}
              onChange={formik.handleChange}
              error={
                formik.touched.streamURL && Boolean(formik.errors.streamURL)
              }
              helperText={formik.touched.streamURL && formik.errors.streamURL}
            />

            <TextField
              margin="dense"
              variant="standard"
              fullWidth
              type="number"
              id="item"
              name="orderNumber"
              label="Numero Orden"
              value={formik.values.orderNumber}
              onChange={formik.handleChange}
              error={
                formik.touched.orderNumber && Boolean(formik.errors.orderNumber)
              }
              helperText={
                formik.touched.orderNumber && formik.errors.orderNumber
              }
            />

            <TextField
              margin="dense"
              variant="standard"
              fullWidth
              id="membership"
              name="membership"
              select
              label="Membresía"
              value={selectedMembership}
              onChange={handleMembershipChange}
            >
              {membershipOptions.map((option) => {
                return (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                );
              })}
            </TextField>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
                marginTop: "20px",
                marginBottom: "5px",
              }}
            >
              <Button
                className="w-50"
                color="primary"
                variant="contained"
                fullWidth
                type="submit"
              >
                Crear
              </Button>
            </Box>
          </Box>
        </form>
      </Grid>
    </Grid>
  );
};

export default AddTrading;
